import { Controller } from "@hotwired/stimulus"

// Drives the admin "Create Gift Pool" form: a searchable organization dropdown
// that, on change, loads the organization-scoped fields partial.
export default class extends Controller {
  static get targets() {
    return ["organization", "fields"];
  }

  static get values() {
    return { fieldsUrl: String };
  }

  connect() {
    this.initOrganizationSelect();
    this.initSearchableSelects();
  }

  initOrganizationSelect() {
    // R8: stays on jQuery's side -- $org is only ever used to drive the select2 plugin
    // (select2 itself, .data() reading the plugin's own ajax config, .on("change") wired to the
    // plugin's change event), not for plain DOM work.
    const $org = $(this.organizationTarget);
    $org.select2({
      width: "100%",
      placeholder: "Search for an organization",
      allowClear: true,
      ajax: {
        url: $org.data("search-url"),
        dataType: "json",
        delay: 250,
      },
    });
    $org.on("change", () => this.loadFields($org.val()));
  }

  loadFields(organizationId) {
    if (!organizationId) {
      this.fieldsTarget.innerHTML = "";
      return;
    }

    const url = `${this.fieldsUrlValue}?organization_id=${encodeURIComponent(organizationId)}`;
    fetch(url, { headers: { Accept: "text/html", "X-Requested-With": "XMLHttpRequest" } })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Failed to load fields (${response.status})`);
        }
        return response.text();
      })
      .then(html => {
        // S1: html is Admin::GiftPoolsController#fields' own server-rendered partial, same
        // origin, admin-only route -- not user- or fetch-response-controlled content.
        this.fieldsTarget.innerHTML = html;
        this.initSearchableSelects();
      })
      .catch(() => {
        this.fieldsTarget.innerHTML = '<p class="text-danger">Could not load fields for this organization. Please try again.</p>';
      });
  }

  initSearchableSelects() {
    $(this.fieldsTarget).find(".gift-pool-searchable").select2({ width: "100%" });
  }
}
